<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    limit: {
      type: Number,
      default: 12,
    },
    grid: {
      type: Boolean,
      default: false,
    },
    carousel: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<template>
  <div
    :class="['text-white lg:flex', { 'overflow-clip': !grid }]"
    data-cy="skele"
  >
    <div
      :class="[
        'flex animate-pulse lg:ml-0',
        { 'ml-4': !carousel },
        {
          'w-[100rem] flex-row': !grid && !carousel,
          'flex-row': !grid && carousel,
          'flex-wrap': grid,
        },
      ]"
    >
      <div
        :class="[
          'mr-4 inline-block h-[22rem] rounded-xl bg-white flex-shrink-0',
          { 'mb-4': grid },
          carousel
            ? 'w-[18rem] md:w-[15.25rem] lg:w-[19rem] xxl:w-[20.125rem] cxxl:w-[23.875rem]'
            : 'w-[19rem]',
        ]"
        v-for="i in limit"
        :key="i"
      />
    </div>
  </div>
</template>
